<template>
<div class="tr_loading"><img src="../assets/images/loading.gif" align="center"></div>
</template>

<script>
import commonUtils from '@/js/workspace/common_util.js';
export default {
    mounted() {
        this.switchHome();
    },
    methods: {
        switchHome() { //通过url上的param登陆到home
            let Base64 = require('js-base64').Base64;
            var getData = commonUtils.getQueryJSON();
            let that = this;
            var routerName = "login";
            if(getData.pay){
                if(getData.pay=='sys'){
                    routerName = "paySys";
                }
                delete getData.pay;
            }
            if (getData) {
                this.Utils.doUserHaveLoginRequest("get", getData)
                    .then(response => {
                        if (response.status == 200) {
                            var user = response.user;
                            if(getData.password){
                              user.password =new String(Base64.encode(getData.password),"utf-8");
                            }else{
                              user.password = null;
                            }
                            commonUtils.setUserToLocal(user);
                            commonUtils.setUserCookies(user);
                            localStorage.setItem('locale', this.getLocaleFrom(user));
                            if(routerName == "login"){
                                //如果未附加参数
                                routerName = "homePage";
                            }
                            that.$store.commit('setleftbannerClick', -1);
                            that.$store.commit('setleftbannerMenuClick', 105);
                        }
                        this.$router.push({
                            name: routerName,
                        });
                    });
            }
        },
        getLocaleFrom(user) {
            switch (user.language) {
                case 'de-DE':
                    return "deutsch";
                case 'fr-FR':
                    return "france";
                case 'pt-PT':
                    return "portuguese";
                case 'ja-JP':
                    return "japanese";
                case 'zh-TW':
                    return "traditionalChinese";
                case 'zh-CN':
                    return "chinese";
                case 'nl-NL':
                    return "nederlands";
                default:
                    return "english";
            }
        }
    }
}
</script>

<style>
.tr_loading {
    height: 100%;
    background: #E6EAF9;
    text-align: center;
    padding-top: 10%;
}
</style>



// WEBPACK FOOTER //
// src/components/turn_page.vue